import { Table } from "@mantine/core";
import React from "react";
interface EntryGridRowProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
}
/**
 * Default table layout component.  That way, if we need to change the main table layouts, it's done in one place
 *
 * @param children Must be of type Mantine's <Table.Thead>..,<Table.Tbody>
 * @param style allows you to define/add custom styles
 * @returns
 */
export const DefaultTableLayout: React.FC<EntryGridRowProps> = ({
  children,
  style,
}) => {
  return (
    <Table
      striped
      highlightOnHover
      withTableBorder
      className="print-table"
      style={{ ...style }}
    >
      {children}
    </Table>
  );
};
